import { render, staticRenderFns } from "./AArrival.vue?vue&type=template&id=7365841d&scoped=true"
import script from "./AArrival.vue?vue&type=script&lang=ts"
export * from "./AArrival.vue?vue&type=script&lang=ts"
import style0 from "./AArrival.vue?vue&type=style&index=0&id=7365841d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7365841d",
  null
  
)

export default component.exports